import React, { ReactNode } from 'react';
import classNames from 'classnames';
import AreaInterface from '../../../../model/Area';
import CityInterface from '../../../../model/City';
import VacancyPlate from '../../../../common/components/VacancyPlate/VacancyPlate';
import VacancyInterface from '../../../../model/Vacancy';
import Grid from '../../../../common/components/Grid/Grid';

interface Props {
  className?: string,
  city: CityInterface,
  area: AreaInterface,
  vacancies: Array<VacancyInterface>,
  itemClass: string
}

class AreaBlock extends React.Component<Props> {
  private currentClass = 'area-block';

  render(): ReactNode {
    const { city, area, className, itemClass, vacancies } = this.props;
    const klass = { [this.currentClass]: true };
    if (className) klass[className] = true;

    return (
      <div key={`${city}-${area}`} className={classNames(klass)}>
        <div id={`${area.uri_alias}`} className="area-block-head">
          <div className="title">{ area.name }</div>
          <div className="count">
            <div className="count__number">
              { vacancies.length }
            </div>
          </div>
        </div>
        <Grid className="area-block-body">
          { vacancies.map((v: VacancyInterface) => <VacancyPlate key={v.id} city={city} vacancy={v} className={itemClass} />)}
        </Grid>
      </div>
    );
  }
}
export default AreaBlock;
